import React from "react";
import GameDetails from "./GameDetails";
import { flunkyInstructionIcons } from "./flunkyInstructionIcons";

const FlunkyBall: React.FC = () => (
    <GameDetails
        game="flunky"
        tagColor="green"
        instructionIcons={flunkyInstructionIcons}
    />
);

export default FlunkyBall;
